var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineNoteSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v1c0 .41-.34.75-.75.75s-.75-.34-.75-.75V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h2c.41 0 .75.34.75.75s-.34.75-.75.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.76 20c0-1.52 1.23-2.75 2.75-2.75s2.75 1.23 2.75 2.75-1.24 2.75-2.75 2.75-2.75-1.23-2.75-2.75zm1.5.01a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.76 20v-6.99c0-.41.34-.75.75-.75s.75.34.75.75V20a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.45 16.39-2.21-.73c-.85-.28-1.48-1.17-1.48-2.06v-.59c0-.61.25-1.14.7-1.46.45-.32 1.03-.39 1.6-.2l2.21.74c.85.28 1.48 1.17 1.48 2.06v.59c0 .61-.25 1.14-.7 1.46-.28.2-.62.3-.97.3-.21 0-.42-.03-.63-.11zm-2.12-3.62c-.04.03-.07.1-.07.24v.59c0 .24.23.56.46.64l2.21.73c.13.04.22.03.25.01.04-.03.08-.1.08-.24v-.59c0-.24-.23-.56-.46-.64l-2.21-.73a.614.614 0 0 0-.16-.03.25.25 0 0 0-.1.02z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineNoteSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-note-square.1abcff32b157a997721eb1af016db9c2.svg";
export { ForwardRef as ReactComponent };